import React from "react";
import PropTypes from "prop-types";
import BaseComponent from "@components/base";
import Mask from "@components/mask";

export default class Loader extends BaseComponent {
  render() {
    const loading = this.produceLoading();
    const { masked, active, inverted, className } = this.props;
    return masked ? (
      <Mask className={masked ? className : null} inverted={inverted} active={active}>
        {loading}
      </Mask>
    ) : (
      loading
    );
  }
  produceLoading() {
    return (
      <div className={this.produceClassName()}>
        {this.header}
        {this.content}
        {this.footer}
      </div>
    );
  }
  produceClassName() {
    const cls = ["loader"];
    const { className, inverted, masked, active, centered } = this.props;
    active && cls.push("active");
    centered && cls.push("centered");
    if (inverted) {
      cls.push("inverted");
    } else if (masked) {
      cls.push("masked");
    }
    className && !masked && cls.push(className);
    return cls.join(" ");
  }
}

const { bool, string } = PropTypes;
Loader.propTypes = {
  className: string,
  inverted: bool,
  masked: bool,
  active: bool,
  centered: bool,
};
Loader.defaultProps = {
  className: "",
  inverted: false,
  masked: false,
  active: false,
  centered: true,
};

require("./index.less");
require("./index.less");